import { BsMicrosoftTeams } from "react-icons/bs";

const TeamCard = ({ teamName, teamEmail }) => {
    return (
        <div className="col-md-4 mb-4">
            <div className="card h-100 shadow-sm">
                <div className="card-body flex-center">
                    <div className="d-flex align-items-center">
                        <BsMicrosoftTeams className="fs-2 me-3" />
                        <div>
                            <h5 className="mb-0">{teamName}</h5>
                            <p className="mb-0">
                                <a href={`mailto:${teamEmail}`} className="text-decoration-none">
                                    {teamEmail}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamCard